/**
 * Typeguard function to make sure a passed width is a fraction width.
 * @internal
 */
export function isFractionWidth(
  width?:
    | number
    | `${number}fr`
    | 'auto'
    | 'content'
    | {
        type: 'auto' | 'content';
        maxWidth?: number;
      },
): width is `${number}fr` {
  return typeof width === 'string' && width.endsWith('fr');
}

/**
 * Typeguard function to make sure a passed width is an extended config.
 * @internal
 */
export function isWidthExtendedConfig(
  width?:
    | number
    | `${number}fr`
    | 'auto'
    | 'content'
    | {
        type: 'auto' | 'content';
        maxWidth?: number;
      },
): width is {
  type: 'auto' | 'content';
  maxWidth?: number;
} {
  return typeof width === 'object';
}
